import { Row, Spin } from "antd";

export const Loader = () => {
  return (
    <Row className="h-100 justify-center align-center">
      <Spin size="large" />
    </Row>
  );
};
